import {Component, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {map, take} from 'rxjs/operators';
import {Store} from '@ngrx/store';
import {OnDestroyMixin, untilComponentDestroyed} from '@w11k/ngx-componentdestroyed';
import {selectConfigState} from '@nettrek-angular-libs/common-store';
import {
  BlackbirdPost,
  DynamicComponentsRenderingComponent,
  RealEstate,
  RenderingItem
} from '@ed-clients/shared';

import {Config} from '../app-init.interface';
import {Marketing} from '../shared-across-dwg-only/marketing-data/marketing-data.interface';
import {SchemaMarkUpMapperService} from '../shared-across-dwg-only/schema-mark-up-mapper.service';
import {ContactPersonLink} from './contact-person-link.interface';
import {HomeDynamicMapperService} from './home-dyamic.mapper';
import {HomeDynamicComponent} from './home-dynamic-component/home-dynamic-component.component';
import {Home, HomeDynamic} from './home.interface';
import {ContactPerson} from "../shared-across-dwg-only/contact-card-view/contact-persons.interface";

@Component({
  selector: 'dwg-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent extends OnDestroyMixin implements OnInit {
  private static BTN_TEXT = 'ZUM INSERAT';
  content: Home;
  posts: BlackbirdPost[];
  filteredPosts: BlackbirdPost[];
  marketings: Marketing[];
  hideNotice = false;
  dynamicData: RenderingItem<HomeDynamic>[];
  realEstates: RealEstate[];
  allContactPersons: ContactPerson[];

  @ViewChild(DynamicComponentsRenderingComponent)
  private dynamicRenderer: DynamicComponentsRenderingComponent<HomeDynamic>;

  constructor(private route: ActivatedRoute,
              private homeMapper: HomeDynamicMapperService,
              private readonly schemaMarkUpMapper: SchemaMarkUpMapperService,
              private store: Store
  ) {
    super();
  }

  ngOnInit(): void {
    this.store.select(selectConfigState).pipe(
      map(config => config.data as Config),
      take(1)
    ).subscribe(configData => {
      this.marketings = configData.marketing;
      this.allContactPersons = configData.contactPersons;
    });

    this.route.data.pipe(
      map(data => data.meta),
      untilComponentDestroyed(this)
    )
      .subscribe((data) => {
        const featuredPosts = data.posts.filter( post => post.featured);

        this.content = data.content;
        this.posts = featuredPosts;
        this.filteredPosts = featuredPosts;
        this.realEstates = data.realEstates;
        this.dynamicData = this.realEstates
          .map(realEstate => this.homeMapper.map(realEstate, HomeComponent.BTN_TEXT))
          .map(viewData => new RenderingItem(HomeDynamicComponent, viewData));
      });
  }

  closeNotice(): void {
    this.hideNotice = true;
  }

  navigateForward(): void {
    this.dynamicRenderer.animateDynamicComponents();
    // this.dynamicRenderer.loadComponent();
  }

  navigateBack(): void {
    this.dynamicRenderer.animateDynamicComponents(true);
    // this.dynamicRenderer.loadComponent(true);
  }

  onPostsFilterChange(post: BlackbirdPost[]): void {
    this.filteredPosts = post;
  }
}
